// extracted by mini-css-extract-plugin
module.exports = {"title":"MobileSelection_title__2ep18","tips":"MobileSelection_tips__2lKPe"};